import React, { useCallback } from 'react';
import { FixedSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import PropTypes from 'prop-types';
import Loader from '../../../Loader/Loader';
import classes from './styles.module.scss';

const SelectOptions = ({
  width, hasNextPage, isNextPageLoading, items, loadNextPage, selectOption, optionPathname, uniqId, tableOption,
  optionWrapperHeight, innerRef,
}) => {
  const itemCount = !items.length ? 10 : hasNextPage ? items.length + 1 : items.length;

  const loadMoreItems = isNextPageLoading ? () => {} : loadNextPage;

  const isItemLoaded = (index) => !hasNextPage || index < items.length;

  const item = useCallback(({ index, style }) => {
    let content;
    if (!isItemLoaded(index)) {
      content = <Loader size={16} borderWidth={2} />;
    } else if (tableOption) {
      content = (
        <div className={classes.table_row}>
          {tableOption.map(({ path, optionWidth }) => (
            <div
              key={items[index]?.id + path}
              style={{ width: optionWidth }}
            >
              {items[index]?.[path]?.trim() || '-'}
            </div>
          ))}
        </div>
      );
    } else if (optionPathname === 'fullName') {
      content = `${items[index]?.firstName} ${items[index]?.lastName}`;
    } else {
      content = optionPathname ? items[index]?.[optionPathname] : items[index];
    }

    return (
      <div
        key={index}
        className={`option_id_${index} ${classes.option_item}`}
        style={{ ...style, borderColor: !isItemLoaded(index) ? 'transparent' : '#E2E5EB' }}
        onClickCapture={() => isItemLoaded(index) && selectOption(items[index])}
      >
        {content}
      </div>
    );
  }, [items]);

  return (
    <div
      id={`option_wrapper${uniqId}`}
    >
      {tableOption && (
        <div className={classes.table_header}>
          {tableOption.map(({ name, optionWidth }) => (
            <div
              key={name}
              style={{ width: optionWidth }}
            >
              {name}
            </div>
          ))}
        </div>
      )}

      <InfiniteLoader
        isItemLoaded={isItemLoaded}
        itemCount={itemCount}
        loadMoreItems={loadMoreItems}
        ref={innerRef}
      >
        {({ onItemsRendered, ref }) => (
          <>
            {!items.length && (
            <div className={classes.option_first_loader_wrapper}>
              <Loader size={40} borderWidth={3} />
            </div>
            )}

            <List
              className={`option_list ${classes.option_list} ${itemCount < 8 ? classes.auto_height : ''}`}
              height={optionWrapperHeight}
              itemCount={itemCount}
              itemSize={30}
              onItemsRendered={onItemsRendered}
              ref={ref}
              width={width - 15}
            >
              {item}
            </List>
          </>
        )}
      </InfiniteLoader>
    </div>
  );
};

SelectOptions.propTypes = {
  width: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
  selectOption: PropTypes.func.isRequired,
  optionPathname: PropTypes.string.isRequired,
  uniqId: PropTypes.string.isRequired,
  hasNextPage: PropTypes.bool,
  isNextPageLoading: PropTypes.bool,
  loadNextPage: PropTypes.func,
  tableOption: PropTypes.array,
  optionWrapperHeight: PropTypes.number,
  innerRef: PropTypes.object,
};

SelectOptions.defaultProps = {
  hasNextPage: () => {},
  isNextPageLoading: false,
  tableOption: null,
  innerRef: null,
  optionWrapperHeight: 209,
  loadNextPage: () => {},
};

export default SelectOptions;
